import { render, staticRenderFns } from "./IbeOption.vue?vue&type=template&id=c324236a"
import script from "./IbeOption.vue?vue&type=script&lang=js"
export * from "./IbeOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports